import { render, staticRenderFns } from "./VideoYouTube.vue?vue&type=template&id=00f6ef02&scoped=true"
import script from "./VideoYouTube.vue?vue&type=script&lang=js"
export * from "./VideoYouTube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6ef02",
  null
  
)

export default component.exports